import script from "./WatercolorTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatercolorTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./WatercolorTemplate.vue?vue&type=style&index=0&id=4c8d604e&lang=css"

const __exports__ = script;

export default __exports__